//import React from 'react';
import React, { lazy, Suspense } from 'react';

import { Route, Switch} from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute.js';

import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react'

const HomePage = lazy(() => import('../../pages/HomePage'));
const LoginPage = lazy(() => import('../../pages/LoginPage'));
const NotFoundPage = lazy(() => import('../../pages/NotFoundPage'));

const UsuarioPage = lazy(() => import('../../pages/UsuarioPage'));
const PerfilPage = lazy(() => import('../../pages/PerfilPage'));
const AcademicoPage = lazy(() => import('../../pages/AcademicoPage'));
const PeriodoPage = lazy(() => import('../../pages/PeriodoPage'));
const ModalidadPage = lazy(() => import('../../pages/ModalidadPage'));
const LicenciaturaPage = lazy(() => import('../../pages/LicenciaturaPage'));
const AreaPage = lazy(() => import('../../pages/AreaPage'));
const ProfilePage = lazy(() => import('../../pages/ProfilePage'));
const DocumentosPage = lazy(() => import('../../pages/DocumentosPage'));

const ActividadPage = lazy(() => import('../../pages/ActividadPage'));
const ActividadOpcionesPage = lazy(() => import('../../pages/ActividadPage/opciones'));
const ActividadPDFPage = lazy(() => import('../../pages/ActividadPage/PDF'));

const PlantrabajoPage = lazy(() => import('../../pages/PlantrabajoPage'));
const PlantrabajoOpcionesPage = lazy(() => import('../../pages/PlantrabajoPage/opciones'));
const PlantrabajoPDFPage = lazy(() => import('../../pages/PlantrabajoPage/PDF'));

const ReporteactividadesPage = lazy(() => import('../../pages/ReporteactividadesPage'));
const ReporteplantrabajoPage = lazy(() => import('../../pages/ReporteplantrabajoPage'));




const Content = () => {
  return (
  <Route>
    <Suspense fallback={
    //   <Segment>
    //    <Dimmer active>
    //     <Loader inverted size='massive'>Cargando</Loader>
    //   </Dimmer>
    //  </Segment>
    <Segment>
      <Loader active size='massive' />
    </Segment>
    }>
      <Switch>
        <PrivateRoute exact path="/" component={HomePage} />
        <Route path="/login" component={LoginPage}/>
        
        <PrivateRoute path="/usuario" component={UsuarioPage} />
        <PrivateRoute path="/perfil" component={PerfilPage} />
        <PrivateRoute path="/academico" component={AcademicoPage} />
        <PrivateRoute path="/periodo" component={PeriodoPage} />
        <PrivateRoute path="/modalidad" component={ModalidadPage} />
        <PrivateRoute path="/licenciatura" component={LicenciaturaPage} />
        <PrivateRoute path="/area" component={AreaPage} />
        <PrivateRoute path="/profile" component={ProfilePage} />
        <PrivateRoute path="/documentos" component={DocumentosPage} />
        <PrivateRoute path="/actividad" component={ActividadPage} />
        <PrivateRoute path="/actividadopciones/:isread/:id/:nombre/:idusuario/:returnpage" component={ActividadOpcionesPage} />
        <PrivateRoute path="/actividadpdf/:id/:nombre/:returnpage" component={ActividadPDFPage} />
        <PrivateRoute path="/plantrabajo" component={PlantrabajoPage} />
        <PrivateRoute path="/plantrabajoopciones/:isread/:id/:nombre/:idusuario/:returnpage" component={PlantrabajoOpcionesPage} />
        <PrivateRoute path="/plantrabajopdf/:id/:nombre/:returnpage" component={PlantrabajoPDFPage} />
        <PrivateRoute path="/reporteactividades" component={ReporteactividadesPage} />
        <PrivateRoute path="/reporteplantrabajo" component={ReporteplantrabajoPage} />
        <Route path='*' component={NotFoundPage} />
      </Switch>
    </Suspense>
  </Route>
  )
}

export default Content
